import axios from 'axios';
import React, { useEffect, useState } from 'react'
import { Swiper, SwiperSlide } from 'swiper/react';
import { EffectCards } from 'swiper/modules';
export default function CategorySlider() {
    const [CategoryImg, setCategoryImg] = useState([]);
    async function GetAllCategorys() {
        let { data } = await axios.get('https://ecommerce.routemisr.com/api/v1/categories');
        console.log(data);
        setCategoryImg(data.data);
    }
    useEffect(() => {
        GetAllCategorys();
    }, []);
    return (
            <Swiper
                effect={'cards'}
                grabCursor={true}
                modules={[EffectCards]}
                className="mySwiper my-5"
            >
                {CategoryImg?.map((Category, index) => (
                    <SwiperSlide key={index}> 
                        <img style={{ height: 240 }} src={Category?.image} className='w-100' />
                        <h5 className='text-center pt-3'>{Category?.name}</h5>
                    </SwiperSlide>
                ))}
            </Swiper>
            
    );
}